import { render } from "./Formato2009.vue?vue&type=template&id=7aff3bf1&scoped=true"
import script from "./Formato2009.vue?vue&type=script&lang=js"
export * from "./Formato2009.vue?vue&type=script&lang=js"

import "./Formato2009.vue?vue&type=style&index=0&id=7aff3bf1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aff3bf1"]])

export default __exports__